/**
 * Vista: Lista de Encuestas de Satisfacción del Producto
 * Formato: AMX-PVTA-FR-04
 */

import posventaService from '../services/posventa.service.js';
import router from '../router/router.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  async render() {
    return `
      <div class="card">
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center;">
          <h2 class="card-title">Encuestas de Satisfacción del Producto</h2>
          ${permisos.canCreate('encuestas_producto') ? `<button class="btn btn-primary" onclick="router.navigate('/posventa/encuestas-producto/nueva')">
            + Nueva Encuesta
          </button>` : ''}
        </div>

        <!-- Estadísticas -->
        <div id="statsContainer" class="stats-container" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(150px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statTotal" style="font-size: 1.5rem; font-weight: bold;">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Total Encuestas</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statPromedio" style="font-size: 1.5rem; font-weight: bold; color: var(--success);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Promedio General</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statMes" style="font-size: 1.5rem; font-weight: bold; color: var(--info);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Este Mes</div>
          </div>
          <div class="stat-card" style="background: var(--bg-secondary); padding: 1rem; border-radius: 8px; text-align: center;">
            <div class="stat-value" id="statRecomendarian" style="font-size: 1.5rem; font-weight: bold; color: var(--primary);">-</div>
            <div class="stat-label" style="color: var(--text-muted); font-size: 0.875rem;">Recomendarían %</div>
          </div>
        </div>

        <!-- Filtros -->
        <div class="filters" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 1.5rem;">
          <div class="form-group">
            <label class="form-label">Buscar</label>
            <input
              type="text"
              id="busqueda"
              class="form-input"
              placeholder="Num. Serie, Propietario..."
            />
          </div>

          <div class="form-group">
            <label class="form-label">Marca</label>
            <select id="marcaFilter" class="form-input">
              <option value="">Todas</option>
              <option value="LOVOL">LOVOL</option>
              <option value="MAQMUT">MAQMUT</option>
              <option value="AOSHENG">AOSHENG</option>
              <option value="BEE MACH">BEE MACH</option>
            </select>
          </div>

          <div class="form-group">
            <label class="form-label">Desde</label>
            <input type="date" id="fechaDesde" class="form-input" />
          </div>

          <div class="form-group">
            <label class="form-label">Hasta</label>
            <input type="date" id="fechaHasta" class="form-input" />
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" onclick="window.encuestasProductoListView.limpiarFiltros()" style="width: 100%;">
              Limpiar Filtros
            </button>
          </div>
        </div>

        <!-- Tabla -->
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th style="width: 30px;"></th>
                <th>Num. Serie</th>
                <th class="tbl-hide-mobile">Fecha</th>
                <th class="tbl-hide-mobile">Usuario</th>
                <th class="tbl-hide-mobile">Modelo</th>
                <th class="tbl-hide-mobile">Hrs de Uso</th>
                <th class="tbl-hide-mobile">Calif. General</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="encuestasTableBody">
              <tr>
                <td colspan="9" style="text-align: center; padding: 2rem;">
                  Cargando encuestas...
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Paginación -->
        <div id="pagination" class="pagination" style="margin-top: 1rem;"></div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('encuestas_producto')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.encuestasProductoListView = this;

    this.currentPage = 1;
    this.limit = 10;
    this.filters = {};

    // Event listeners
    document.getElementById('busqueda').addEventListener('input', (e) => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.filters.search = e.target.value;
        this.currentPage = 1;
        this.cargarEncuestas();
      }, 500);
    });

    document.getElementById('marcaFilter').addEventListener('change', (e) => {
      if (e.target.value === '') {
        delete this.filters.marca;
      } else {
        this.filters.marca = e.target.value;
      }
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    document.getElementById('fechaDesde').addEventListener('change', (e) => {
      this.filters.fecha_desde = e.target.value;
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    document.getElementById('fechaHasta').addEventListener('change', (e) => {
      this.filters.fecha_hasta = e.target.value;
      this.currentPage = 1;
      this.cargarEncuestas();
    });

    await this.cargarEstadisticas();
    await this.cargarEncuestas();
  },

  async cargarEstadisticas() {
    try {
      const response = await posventaService.obtenerEstadisticas();
      const stats = response.data || response;

      document.getElementById('statTotal').textContent = stats.encuestas_producto?.total || 0;
      document.getElementById('statPromedio').textContent = stats.encuestas_producto?.promedio_general
        ? stats.encuestas_producto.promedio_general.toFixed(1) : '-';
      document.getElementById('statMes').textContent = stats.encuestas_producto?.este_mes || 0;
      document.getElementById('statRecomendarian').textContent = stats.encuestas_producto?.porcentaje_recomendarian
        ? stats.encuestas_producto.porcentaje_recomendarian + '%' : '-';
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  async cargarEncuestas() {
    try {
      const params = {
        page: this.currentPage,
        limit: this.limit,
        ...this.filters
      };

      const response = await posventaService.listarEncuestasProducto(params);
      // La API devuelve { success, data: [...], pagination: {...} }
      const encuestas = Array.isArray(response.data) ? response.data : [];
      const pagination = response.pagination || { page: 1, totalPages: 1, total: 0 };

      this.renderEncuestas(encuestas);
      this.renderPaginacion(pagination);
    } catch (error) {
      toast.error('Error al cargar encuestas');
      console.error('Error:', error);
      this.renderEncuestas([]);
    }
  },

  renderEncuestas(encuestas) {
    const tbody = document.getElementById('encuestasTableBody');

    if (!encuestas || encuestas.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="9" style="text-align: center; padding: 2rem;">
            No se encontraron encuestas de producto
          </td>
        </tr>
      `;
      return;
    }

    const fechaFmt = (f) => f ? new Date(f).toLocaleDateString('es-MX') : '-';
    const estadoBadge = (e) => `<span class="badge ${e.completada ? 'badge-success' : 'badge-warning'}">${e.completada ? 'Completada' : 'Pendiente'}</span>`;
    const acciones = (e) => e.completada
      ? `${permisos.canView('encuestas_producto') ? `<button class="btn btn-sm btn-primary" onclick="window.encuestasProductoListView.verDetalle(${e.id})">Ver</button>` : ''}`
      : `${permisos.canEdit('encuestas_producto') ? `<button class="btn btn-sm btn-primary" onclick="window.encuestasProductoListView.verDetalle(${e.id})">Editar</button>` : ''}
         ${permisos.canDelete('encuestas_producto') ? `<button class="btn btn-sm btn-danger" onclick="window.encuestasProductoListView.eliminarEncuesta(${e.id})">Eliminar</button>` : ''}`;

    tbody.innerHTML = encuestas.map(e => `
      <tr>
        <td>
          <button class="tbl-expand-btn" onclick="window.encuestasProductoListView.toggleRow(${e.id})">&#9654;</button>
        </td>
        <td><strong>${e.num_serie}</strong></td>
        <td class="tbl-hide-mobile">${fechaFmt(e.fecha_evaluacion)}</td>
        <td class="tbl-hide-mobile">${e.usuario || '-'}</td>
        <td class="tbl-hide-mobile">${e.modelo || '-'} (${e.marca || '-'})</td>
        <td class="tbl-hide-mobile">${e.horas_uso || '-'} hrs</td>
        <td class="tbl-hide-mobile">
          <span class="badge ${this.getCalificacionBadge(e.promedio_general)}">
            ${e.promedio_general != null ? e.promedio_general + '/5' : '-'}
          </span>
        </td>
        <td class="tbl-hide-mobile">${estadoBadge(e)}</td>
        <td class="tbl-hide-mobile">
          <div style="display: flex; gap: 0.5rem;">${acciones(e)}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-enc-${e.id}">
        <td colspan="9" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Fecha</dt><dd>${fechaFmt(e.fecha_evaluacion)}</dd>
            <dt>Usuario</dt><dd>${e.usuario || '-'}</dd>
            <dt>Marca</dt><dd>${e.marca || '-'}</dd>
            <dt>Modelo</dt><dd>${e.modelo || '-'}</dd>
            <dt>Hrs de Uso</dt><dd>${e.horas_uso || '-'} hrs</dd>
            <dt>Calif.</dt><dd><span class="badge ${this.getCalificacionBadge(e.promedio_general)}">${e.promedio_general != null ? e.promedio_general + '/5' : '-'}</span></dd>
            <dt>Recomendaría</dt><dd><span class="badge ${e.p3_recomendaria ? 'badge-success' : 'badge-danger'}">${e.p3_recomendaria ? 'Sí' : 'No'}</span></dd>
            <dt>Estado</dt><dd>${estadoBadge(e)}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">
            ${acciones(e)}
          </div>
        </td>
      </tr>
    `).join('');
  },

  getCalificacionBadge(calificacion) {
    if (calificacion >= 4) return 'badge-success';
    if (calificacion >= 3) return 'badge-warning';
    return 'badge-danger';
  },

  renderPaginacion(pagination) {
    const container = document.getElementById('pagination');
    const { page, totalPages } = pagination;

    if (totalPages <= 1) {
      container.innerHTML = '';
      return;
    }

    let html = '<div style="display: flex; gap: 0.5rem; justify-content: center; align-items: center;">';

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.encuestasProductoListView.cambiarPagina(${page - 1})"
        ${page === 1 ? 'disabled' : ''}
      >
        Anterior
      </button>
    `;

    for (let i = 1; i <= totalPages; i++) {
      if (i === page) {
        html += `<button class="btn btn-sm btn-primary" disabled>${i}</button>`;
      } else if (i === 1 || i === totalPages || (i >= page - 2 && i <= page + 2)) {
        html += `
          <button
            class="btn btn-sm btn-secondary"
            onclick="window.encuestasProductoListView.cambiarPagina(${i})"
          >
            ${i}
          </button>
        `;
      } else if (i === page - 3 || i === page + 3) {
        html += '<span>...</span>';
      }
    }

    html += `
      <button
        class="btn btn-sm btn-secondary"
        onclick="window.encuestasProductoListView.cambiarPagina(${page + 1})"
        ${page === totalPages ? 'disabled' : ''}
      >
        Siguiente
      </button>
    `;

    html += '</div>';
    container.innerHTML = html;
  },

  cambiarPagina(page) {
    this.currentPage = page;
    this.cargarEncuestas();
  },

  limpiarFiltros() {
    document.getElementById('busqueda').value = '';
    document.getElementById('marcaFilter').value = '';
    document.getElementById('fechaDesde').value = '';
    document.getElementById('fechaHasta').value = '';
    this.filters = {};
    this.currentPage = 1;
    this.cargarEncuestas();
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-enc-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  verDetalle(id) {
    router.navigate(`/posventa/encuestas-producto/${id}`);
  },

  async eliminarEncuesta(id) {
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar esta encuesta? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await posventaService.eliminarEncuestaProducto(id);
          toast.success('Encuesta eliminada');
          this.cargarEstadisticas();
          this.cargarEncuestas();
        } catch (error) {
          toast.error(error.message || 'Error al eliminar');
        }
      }
    );
  }
};
